import { render } from "./CreateGroupSurvey.vue?vue&type=template&id=55039e84"
import script from "./CreateGroupSurvey.vue?vue&type=script&lang=js"
export * from "./CreateGroupSurvey.vue?vue&type=script&lang=js"

import "./CreateGroupSurvey.vue?vue&type=style&index=0&id=55039e84&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__